import {NavLink} from 'react-router-dom';
import {Detail} from './Detail';
import st from './Representative.module.scss';
import arrow from 'assets/images/svg/arrow-icon-lf.svg';

export const Representative = () => {
    return (
        <div className={st.section}>
            <div className="wrapper">
                <div className={st.head}>
                    <NavLink to="/" className={st.link}>
                        <img src={arrow} alt="" width={24} height={24} />
                        <span>Назад</span>
                    </NavLink>
                </div>
                <Detail/>
            </div>
        </div>
    )
}
